import React from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@/components/ui/accordion';
import { EmptyState } from '@/components/custom/empty-state';
import { PerformanceBarRow, PerformanceLegend } from './PerformanceBarRow';

export function KnowledgeAreaAccordion({ simulados = [], showAverages = true }) {
  if (!simulados.length) {
    return (
      <EmptyState
        type="data"
        variant="plain"
        text="Nenhum dado disponível"
      />
    );
  }

  return (
    <>
      <Accordion
        type="single"
        collapsible
        defaultValue={simulados[0]?.id?.toString()}
      >
        {simulados.map(simulado => (
          <AccordionItem
            key={simulado.id}
            value={simulado.id.toString()}
          >
            <AccordionTrigger className={showAverages ? 'grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)_auto]' : undefined}>
              <span className={showAverages ? 'min-w-0 truncate font-bold text-primary-dark' : 'whitespace-nowrap font-bold text-primary-dark'}>{simulado.label}</span>
              {showAverages && (
                <>
                  <span className="flex items-center gap-2 whitespace-nowrap text-sm text-neutral-darker">
                    <span className="whitespace-nowrap rounded-lg bg-[#F1F5FA] px-2 py-1">Média U.E: {simulado.ueAverage}%</span>
                    <span className="whitespace-nowrap rounded-lg bg-[#F1F5FA] px-2 py-1">Média das U.Es: {simulado.networkAverage}%</span>
                  </span>
                  <span aria-hidden="true" />
                </>
              )}
            </AccordionTrigger>
            <AccordionContent>
              {simulado.areas.length > 0 ? (
                <div className="flex flex-col gap-4">
                  {simulado.areas.map(area => (
                    <PerformanceBarRow
                      key={area.label}
                      label={area.label}
                      low={area.low}
                      mid={area.mid}
                      high={area.high}
                      showAverage={false}
                    />
                  ))}
                </div>
              ) : (
                <p className="mb-0 text-sm text-neutral">Sem dados detalhados para este simulado.</p>
              )}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <PerformanceLegend />
    </>
  );
}
